module.exports = __webpack_public_path__ + "static/media/Java_logo.20f3cdd7.png";